import { Box, Typography } from '@mui/material';
import { AdviseCurrentSupplier, AdviseSupplierInvoice } from '../../../../types/advise';
import { TextButton } from '../../../Atoms/TextButton';
import { useEngagementEditor } from './EngagementEditorContext';
import { InvoiceSummary } from './InvoiceSummary';
import { InvoiceTabs } from './InvoiceTabs';
import { ManualSpendEntry } from './ManualSpendEntry';

export interface InvoiceViewProps {
  supplier: AdviseCurrentSupplier;
  invoice: AdviseSupplierInvoice | null;
  onBack: () => void;
}

const UNGUARDED = () => undefined;

/** A supplier's invoice, or its spend entered by hand, full page, with its contract and baseline. */
export const InvoiceView = ({ supplier, invoice, onBack }: InvoiceViewProps) => {
  const { unsavedDraft } = useEngagementEditor();
  const reportChanged = unsavedDraft?.setChanged ?? UNGUARDED;

  return (
    <Box className="flex flex-col gap-4">
      <Box className="flex flex-col gap-2 border-b border-grey-2 pb-4">
        <TextButton
          className="self-start"
          onClick={() => (unsavedDraft ? unsavedDraft.leave(onBack) : onBack())}>
          ← Back to Current Suppliers
        </TextButton>
        <Typography
          variant="h6"
          component="h2">
          {supplier.name}
        </Typography>
        {invoice && <InvoiceSummary invoice={invoice} />}
      </Box>
      {invoice ? (
        <InvoiceTabs
          supplier={supplier}
          invoice={invoice}
          onChangedChange={reportChanged}
        />
      ) : (
        <ManualSpendEntry
          supplier={supplier}
          invoice={null}
          onChangedChange={reportChanged}
        />
      )}
    </Box>
  );
};
